import { render, staticRenderFns } from "./TaskItem.vue?vue&type=template&id=988b4bd8&scoped=true&"
import script from "./TaskItem.vue?vue&type=script&lang=ts&"
export * from "./TaskItem.vue?vue&type=script&lang=ts&"
import style0 from "./TaskItem.vue?vue&type=style&index=0&id=988b4bd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988b4bd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
